
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyBZxrZ7St43rezgjBUXcyy51SZve41Gn-s",
    authDomain: "predictclaw.firebaseapp.com",
    projectId: "predictclaw",
    storageBucket: "predictclaw.firebasestorage.app",
    messagingSenderId: "395354291800",
    appId: "1:395354291800:web:ca838d92168fcdcfa3d42d",
    measurementId: "G-7LKTPNRBCK"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export const VAPID_KEY = "BC8rrdhwgq5mKM9IpKwG2o-OllimrqSD702S-N6d6dwDj3OBJSIQRCdkLKoJ0NP86nsPzEPCZgEDVourSYmAWLg";

export { auth, db, app };
